
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CompanyModel } from './Entities.GormCrm.Company';
import { OrderModel } from './Entities.GormCrm.Order';
import { Model, ModelProperty } from 'models/Model';


export class SaleAgreementModel extends Model<SaleAgreementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'ownerId', type: 'string' },
		{ name: 'creatorId', type: 'string' },
		{ name: 'companyId', type: 'string' },
		{ name: 'comment', type: 'string' },
		{ name: 'company', type: 'CompanyModel', isHidden: true, isObject: true, new: () => { return new CompanyModel }, properties: () => { return CompanyModel.classProperties } },
		{ name: 'orders', type: 'OrderModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public created?: Date;
	public ownerId?: string;
	public creatorId?: string;
	public companyId?: string;
	public comment: string;
	public company?: CompanyModel;
	public orders: OrderModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.created = undefined;
		this.ownerId = undefined;
		this.creatorId = undefined;
		this.companyId = undefined;
		this.comment = '';
		this.company = undefined;
		this.orders = [];
		
	}
	getProperties(){
		return SaleAgreementModel.classProperties;
	}
}

